import { ContactChannels } from '../../../../../features/messages/components/ContactChannels';
import { ContactForm } from '../../../../../features/messages/components/ContactForm';
import { useI18n } from '../../../../../shared/i18n';
import { useData } from '../../../../../shared/lib';
import { Container, Eyebrow, Section } from '../../../../../shared/ui';
import type { ContactPageData } from './+data';

export default function Page() {
  const { t } = useI18n();
  const { formToken, services, channels, defaultServiceSlug } = useData<ContactPageData>();

  return (
    <Section spacing="lg">
      <Container className="grid grid-cols-1 gap-12 lg:grid-cols-[1fr_20rem]">
        <div className="flex flex-col gap-6">
          <div className="flex flex-col gap-3">
            {/* A route, not a translated label — see the same choice on the
                other listings. */}
            <Eyebrow>
              <span dir="ltr">/contact</span>
            </Eyebrow>
            <h1 className="text-4xl font-bold tracking-tight sm:text-5xl">
              {t('common.contact.heading')}
            </h1>
          </div>

          {/*
            The form is one opaque paper card on the light page, matching the
            portfolio filter panel and every other public card.
          */}
          <div className="hs-card rounded-lg p-6 sm:p-8">
            <ContactForm
              formToken={formToken}
              services={services}
              defaultServiceSlug={defaultServiceSlug}
            />
          </div>
        </div>
        <ContactChannels {...channels} />
      </Container>
    </Section>
  );
}
